import { action, payload } from 'ts-action'
import { INetOption } from '@network/models/net-option.model'
import { IError, IPayload } from '@network/models/global.model'

export const NetOptionsFetching = action(
  'NetOptionsFetching',
  payload<boolean>(),
)

export const GetNetOptions = action(
  'GetNetOptions',
  payload<IPayload<INetOption[]>>(),
)

export const GetNetOptionsErrors = action(
  'GetNetOptionsErrors',
  payload<IError>(),
)
